var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 726,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 727,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 728,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 729,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 730,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2636;